/** @prettier */
import React from "react";
import { TestRunnerDispatch } from "./testRunnerState";
import ActionBar, { ActionBarItem } from "../View/ActionBar";

export type ActionBarProps = {
    questionIsFlagged: boolean;
    dispatch: TestRunnerDispatch;
};
const TestRunnerActionBar = ({
    questionIsFlagged,
    dispatch,
}: ActionBarProps) => (
    <ActionBar>
        <ActionBarItem
            icon="step-backward"
            title="Return to previous question"
            onClick={() => dispatch({ event: "selectQuestion", index: "prev" })}
        />
        <ActionBarItem
            icon="step-forward"
            title="Go to next question"
            onClick={() => dispatch({ event: "selectQuestion", index: "next" })}
        />
        <ActionBarItem
            icon="pause"
            title={"Pause the test"}
            onClick={() => {
                dispatch({ event: "pauseTest" });
            }}
        />
        <ActionBarItem
            icon="flag"
            active={questionIsFlagged}
            title={
                questionIsFlagged
                    ? "Remove flag from question"
                    : "Flag question"
            }
            onClick={() => dispatch({ event: "toggleFlagged" })}
        />
        <ActionBarItem
            icon="eraser"
            title="Clear selected answer"
            onClick={() => dispatch({ event: "selectAnswer", answer: "none" })}
        />
        <ActionBarItem
            icon="fast-forward"
            title="Go to test review"
            onClick={() => dispatch({ event: "gotoReview" })}
        />
    </ActionBar>
);
export default TestRunnerActionBar;
